import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { b2bGetStreams, b2bCreateStream, b2bGetStream, b2bUpdateStream, b2bDeleteStream, b2bGetTemplates } from '../../../lib/adminApi';
import AdminSidebar from '../../../components/AdminSidebar';

const NAVY = '#0a2540'; const ORANGE = '#F37428'; const BLUE = '#0176CE';

export default function B2BStreams() {
  const [streams, setStreams] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [selectedSteps, setSelectedSteps] = useState([]);
  const [form, setForm] = useState({ stream_name: '', from_name: '', from_email: '' });
  const [steps, setSteps] = useState([{ step_number: 1, template_id: '', delay_days: 0 }]);
  const [saving, setSaving] = useState(false);
  const [isNew, setIsNew] = useState(false);

  function load() {
    setLoading(true);
    b2bGetStreams().then(r => { setStreams(r.streams || []); setLoading(false); }).catch(() => setLoading(false));
    b2bGetTemplates().then(r => setTemplates(r.templates || [])).catch(() => {});
  }

  useEffect(() => { load(); }, []);

  async function handleSelect(s) {
    setIsNew(false);
    const full = await b2bGetStream(s.stream_id);
    setSelected(full.stream);
    setSelectedSteps(full.steps);
    setForm({ stream_name: full.stream.stream_name, from_name: full.stream.from_name, from_email: full.stream.from_email });
    setSteps(full.steps.length ? full.steps.map(st => ({ step_number: st.step_number, template_id: st.template_id, delay_days: st.delay_days })) : [{ step_number: 1, template_id: '', delay_days: 0 }]);
  }

  function handleNew() {
    setIsNew(true); setSelected(null); setSelectedSteps([]);
    setForm({ stream_name: '', from_name: '', from_email: '' });
    setSteps([{ step_number: 1, template_id: '', delay_days: 0 }]);
  }

  function addStep() {
    setSteps(prev => [...prev, { step_number: prev.length + 1, template_id: '', delay_days: 3 }]);
  }

  function removeStep(i) {
    setSteps(prev => prev.filter((_, idx) => idx !== i).map((s, idx) => ({ ...s, step_number: idx + 1 })));
  }

  function updateStep(i, field, val) {
    setSteps(prev => prev.map((s, idx) => idx === i ? { ...s, [field]: val } : s));
  }

  async function handleSave(e) {
    e.preventDefault(); setSaving(true);
    const payload = { ...form, steps: steps.map(s => ({ ...s, template_id: parseInt(s.template_id), delay_days: parseInt(s.delay_days) || 0 })) };
    try {
      if (isNew) {
        const r = await b2bCreateStream(payload);
        await load();
        const full = await b2bGetStream(r.stream_id);
        setSelected(full.stream); setIsNew(false);
        setSteps(full.steps.map(st => ({ step_number: st.step_number, template_id: st.template_id, delay_days: st.delay_days })));
      } else {
        await b2bUpdateStream(selected.stream_id, payload);
        load();
      }
    } catch (err) { alert(err.message); }
    setSaving(false);
  }

  return (
    <div style={s.page}>
      <AdminSidebar active="b2b-streams" />
      <main style={s.main}>
        <div style={s.layout}>
          {/* List */}
          <div style={s.sidebar}>
            <div style={s.sidebarHeader}>
              <span style={s.sidebarTitle}>Email Streams</span>
              <button style={s.newBtn} onClick={handleNew}>+ New</button>
            </div>
            <div style={{ overflowY: 'auto', flex: 1 }}>
              {loading && <div style={{ padding: 16, color: '#64748b', fontSize: 13 }}>Loading…</div>}
              {streams.map(st => (
                <div key={st.stream_id}
                  style={{ ...s.listItem, background: selected?.stream_id === st.stream_id ? 'rgba(243,116,40,0.06)' : 'transparent', borderLeft: selected?.stream_id === st.stream_id ? `3px solid ${ORANGE}` : '3px solid transparent' }}
                  onClick={() => handleSelect(st)}>
                  <div style={{ fontWeight: 500, color: NAVY, fontSize: 13 }}>{st.stream_name}</div>
                  <div style={{ color: '#64748b', fontSize: 11, marginTop: 2 }}>{st.step_count} steps · {st.from_email}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Editor */}
          <div style={s.editor}>
            {!(selected || isNew) ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#94a3b8', fontSize: 14 }}>
                Select a stream or create a new one
              </div>
            ) : (
              <form onSubmit={handleSave} style={{ display: 'flex', flexDirection: 'column', gap: 16, overflowY: 'auto' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <h2 style={{ margin: 0, color: NAVY, fontSize: 18 }}>{isNew ? 'New Stream' : 'Edit Stream'}</h2>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {!isNew && <button type="button" style={s.deleteBtn} onClick={async () => { if (confirm('Delete stream?')) { await b2bDeleteStream(selected.stream_id); setSelected(null); load(); } }}>Delete</button>}
                    <button type="submit" style={s.primaryBtn} disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
                  <label style={s.label}>Stream Name<input required style={s.inp} value={form.stream_name} onChange={e => setForm(f => ({ ...f, stream_name: e.target.value }))} /></label>
                  <label style={s.label}>From Name<input required style={s.inp} value={form.from_name} onChange={e => setForm(f => ({ ...f, from_name: e.target.value }))} /></label>
                  <label style={s.label}>From Email<input required style={s.inp} type="email" value={form.from_email} onChange={e => setForm(f => ({ ...f, from_email: e.target.value }))} /></label>
                </div>

                <div>
                  <div style={{ color: NAVY, fontSize: 13, fontWeight: 600, marginBottom: 12 }}>Steps</div>
                  {steps.map((step, i) => (
                    <div key={i} style={s.stepRow}>
                      <div style={s.stepNum}>{step.step_number}</div>
                      <div style={{ flex: 1 }}>
                        <select required style={s.inp} value={step.template_id} onChange={e => updateStep(i, 'template_id', e.target.value)}>
                          <option value="">Select template…</option>
                          {templates.map(t => <option key={t.template_id} value={t.template_id}>{t.template_name}</option>)}
                        </select>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' }}>
                        <input style={{ ...s.inp, width: 60, textAlign: 'center' }} type="number" min="0" value={step.delay_days} onChange={e => updateStep(i, 'delay_days', e.target.value)} />
                        <span style={{ color: '#64748b', fontSize: 12 }}>days after {i === 0 ? 'launch' : 'prev email'}</span>
                      </div>
                      {steps.length > 1 && <button type="button" style={s.removeBtn} onClick={() => removeStep(i)}>✕</button>}
                    </div>
                  ))}
                  <button type="button" style={s.addStepBtn} onClick={addStep}>+ Add Step</button>
                </div>
              </form>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

const s = {
  page: { display: 'flex', minHeight: '100vh', fontFamily: "'Inter', system-ui, sans-serif" },
  main: { flex: 1, background: '#f0f5fb', overflow: 'hidden', display: 'flex', flexDirection: 'column' },
  layout: { display: 'flex', flex: 1, overflow: 'hidden', margin: '24px 32px', gap: 20 },
  sidebar: { width: 260, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  sidebarHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', borderBottom: '1px solid #f1f5f9' },
  sidebarTitle: { color: '#0a2540', fontSize: 13, fontWeight: 600 },
  newBtn: { background: '#F37428', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' },
  listItem: { padding: '12px 16px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9' },
  editor: { flex: 1, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 28, display: 'flex', flexDirection: 'column', overflow: 'auto' },
  primaryBtn: { background: '#F37428', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  deleteBtn: { background: 'rgba(239,68,68,0.08)', border: 'none', borderRadius: 8, color: '#ef4444', cursor: 'pointer', fontSize: 13, padding: '7px 14px' },
  label: { color: '#374151', fontSize: 12, fontWeight: 500, display: 'flex', flexDirection: 'column', gap: 4 },
  inp: { padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 13, width: '100%', boxSizing: 'border-box', marginTop: 2 },
  stepRow: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, padding: '12px 16px', background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0' },
  stepNum: { width: 24, height: 24, borderRadius: '50%', background: '#F37428', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, flexShrink: 0 },
  addStepBtn: { background: 'transparent', border: '1px dashed #cbd5e1', borderRadius: 8, color: '#64748b', cursor: 'pointer', fontSize: 13, padding: '8px 16px', width: '100%', marginTop: 4 },
  removeBtn: { background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 14, flexShrink: 0 },
};
